function r(e) {
  switch (e) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "PLN":
      return "zł";
    case "SEK":
    case "NOK":
    case "DKK":
    case "ISK":
      return "kr";
    default:
      return "kr";
  }
}
export {
  r as default
};
